import { Cross2Icon as CrossIcon } from '@radix-ui/react-icons'
import { keyframes } from 'ui'

import { Toast as ToastType, removeToast } from 'store/toasts.state'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

const toastShow = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(50%)'
  },
  '100%': {
    transform: 'translateY(0)',
    opacity: 1
  }
})

export const Toast = (props: ToastType) => {
  const { id, content, type } = props
  const { title, text, button } = content

  const onRemoveToast = () => {
    removeToast(id)
  }

  const getBorderColor = () => {
    switch (type) {
      case 'success':
        return '$success'
      case 'error':
        return '$error'
      case 'info':
      default:
        return '$transparent'
    }
  }

  return (
    <Box
      relative
      css={{
        borderRadius: '$sm',
        boxShadow: '$sm',
        width: 280,
        overflow: 'hidden',
        animation: `${toastShow} .3s ease`,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '$bg3',
        bgc: '$bg1',
        '.dark &': {
          borderWidth: 0
        }
      }}
    >
      <Box
        absolute
        css={{ top: 0, height: 5, width: '$full', bgc: getBorderColor() }}
      />

      <Text
        as="button"
        color="text2"
        colorHover="text1"
        transition
        onClick={onRemoveToast}
        css={{
          position: 'absolute',
          top: '$3',
          right: '$2'
        }}
      >
        <CrossIcon width={16} height={16} />
      </Text>
      <Box css={{ padding: '$3' }}>
        <Text as="div" weight="semiBold" size="sm" css={{ pr: '$3' }}>
          {title}
        </Text>
        {!!text && (
          <Text as="p" size="xs" color="text2" css={{ mt: '$1' }}>
            {text}
          </Text>
        )}
        {!!button && (
          <Box css={{ mt: '$2' }}>
            <Button variant="secondary" {...button} size="sm" />
          </Box>
        )}
      </Box>
    </Box>
  )
}
